import { SelectOption } from "@/types";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Stack";
import AddIcon from "@mui/icons-material/Add";

export interface ChipsListProps<V extends string | number = string> {
  selectedOptions: SelectOption<V>[];
  deselectOption: (value: V) => void;
  onAddNewOptionClick: (e: React.MouseEvent<HTMLElement>) => void;
  actionLabel?: string;
}

export function ChipsList<V extends string | number = string>({
  selectedOptions,
  deselectOption,
  onAddNewOptionClick,
  actionLabel,
}: ChipsListProps<V>) {
  const addChip = (
    <Chip
      icon={<AddIcon />}
      label={actionLabel || "Add Option"}
      onClick={onAddNewOptionClick}
    />
  );

  return (
    <Box display="flex" flexDirection="row" flexWrap="wrap" gap={1}>
      {addChip}
      {selectedOptions.map((option) => (
        <Chip
          key={option.value}
          label={option.label}
          onDelete={() => deselectOption(option.value)}
        />
      ))}
    </Box>
  );
}
